import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEraser: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconEraser"><Path d="M14.5 3L2 15L7.5 20.5H10.5L21 10L14.5 3Z" stroke="currentColor"/><Path d="M6.07227 11.0905L12.9999 18" stroke="currentColor"/></CentralIconBase>;
});

export default IconEraser;
